module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-root"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('div', {
    staticClass: "header-image"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name-box"
  }, [_c('span', [_vm._v("邱国辉")])]), _vm._v(" "), _c('div', {
    staticClass: "message-box"
  }, [_c('p', [_c('span', [_vm._v("WEB前端工程师")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("530784837@qq.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ed796e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/resume/components/page1.vue
// module id = 191
// module chunks = 0